module.exports = "label.required:before, span.required:before {\r\n    content: \"*\"!important;\r\n    color: #f43 ;\r\n    margin-right: 2px;\r\n}\r\n\r\n"